import { FeSupportUserStatus } from "@/types/agents.ts";

export const getStatus = (status: FeSupportUserStatus) => {
  switch (status) {
    case FeSupportUserStatus.supportUserEnabled:
      return "green";
    case FeSupportUserStatus.supportUserInviting:
      return "orange";
    case FeSupportUserStatus.supportUserDisabled:
    default:
      return "grey";
  }
};

export const getStatusLabel = (status: FeSupportUserStatus) => {
  switch (status) {
    case FeSupportUserStatus.supportUserEnabled:
      return "active";
    case FeSupportUserStatus.supportUserInviting:
      return "waiting";
    case FeSupportUserStatus.supportUserDisabled:
    default:
      return "inactive";
  }
};
